import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    useMediaQuery,
    useTheme,
    IconButton,
    Box,
    Divider,
    Typography,
  } from "@mui/material";
  import CloseIcon from "@mui/icons-material/Close";

export default function ConfirmationPopup({open,onClose,title,component, maxWidth, showDivider,textBody,handleUpdateStatus, approveButton, cancelButton}) {
 
    const handleClose=()=>{
        onClose()
    }
    const handleUpdateStatus1=()=>{
        handleUpdateStatus()
    }

 return (
<>
      <Dialog
      onClose={onClose}
      open={open}
      
      maxWidth={maxWidth}
      fullWidth

    >
     
      <DialogTitle
        variant="h3"
      >
    
{title}
        {/* <IconButton
          edge="end"
        
          onClick={onClose}
          aria-label="close"
          sx={{ position: "absolute", right: 15, top: 2 }}
        >
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>
      {showDivider && <Divider />}
      <DialogContent>
        <Typography variant='subtitle1' textAlign="center"> {textBody}</Typography>
       </DialogContent>
      <DialogActions>
      <Button variant='contained'  color='error' onClick={handleClose}>{cancelButton?cancelButton:"No"}</Button>
      <Button variant='contained'  color='secondary' onClick={handleUpdateStatus1}>{approveButton?approveButton:"Yes"}</Button>
      
      </DialogActions>
    
    </Dialog>
   </>
  )
}
